export default __webpack_public_path__ + "static/taylor-gang-884d664b8eb5d98f357cffdeee4da0d0.svg";